import Vue from 'vue';
import {
  getLeases as getLeasesCall,
  getLease as getLeaseCall,
  hasLeases as hasLeasesCall
} from '@/api/leases';
import { GLOBAL_ERROR } from '@/utils/constants';

/**
 * Fetch a boolean flag as `true` if the user has a lease
 *
 * @param commit
 * @returns {Promise<*>}
 */
export function getHasLeases({ commit }) {
  return new Promise(async (resolve) => {
    commit('setState', ['leasesLoading', true]);
    const hasLeases = await hasLeasesCall();
    commit('setState', ['hasLeases', hasLeases]);
    commit('setState', ['leasesLoading', false]);
    return resolve();
  });
}

/**
 * Get a list of leases for the user and store it in this modules state
 *
 * @param commit
 * @param dispatch
 * @param state
 * @returns {Promise<*>}
 */
export function getLeases({ commit, dispatch, state }) {
  return new Promise(async (resolve, reject) => {
    try {
      commit('setState', ['leasesLoading', true]);
      let leases = await getLeasesCall();
      const hasLeases = Array.isArray(leases) ? Boolean(leases.length) : false;
      commit('setState', ['hasLeases', hasLeases]);

      // Default selected lease to the first in the list
      if (hasLeases && !state.selectedLease.id) {
        commit('setSelectedLease', leases[0]);
      }

      commit('setLeases', leases);
      commit('setState', ['leasesLoading', false]);
      resolve();
    } catch (err) {
      commit('setState', ['leasesLoading', false]);
      // eslint-disable-next-line
      console.error(err);
      Vue.prototype.$euiNotifications.emit({
        notification: GLOBAL_ERROR,
        action: () => dispatch('getLeases')
      });
      return reject();
    }
  });
}

/**
 * Get a leases details from a given id
 *
 * @param commit
 * @param dispatch
 * @param leaseId
 * @returns {Promise<*>}
 */
export function getLease({ commit, dispatch }, leaseId) {
  return new Promise(async (resolve, reject) => {
    try {
      commit('setState', ['leaseLoading', true]);
      const lease = await getLeaseCall(leaseId);
      commit('setLease', lease);
      commit('setState', ['leaseLoading', false]);
      resolve();
    } catch (err) {
      commit('setState', ['leaseLoading', false]);
      // eslint-disable-next-line
      console.error(err);
      Vue.prototype.$euiNotifications.emit({
        notification: GLOBAL_ERROR,
        action: () => dispatch('getLease')
      });
      return reject();
    }
  });
}
